
import Vue from "vue";
import { AuthService } from "../../services/auth-service";
import AppChangePassword from "@/components/account/ChangePasswordCard.vue";
import AppAccountSettings from "@/components/account/AccountSettings.vue";
import AppBillingAddress from "@/components/account/BillingAddressEditCard.vue";
import AppLockScreenNfcBadges from "@/components/account/LockScreenNfcBadges.vue";
import AppQrLogin from "@/components/account/QrLoginCard.vue";
import { LockScreenService } from "@/services/lockscreen-service";

export default Vue.extend({
	data(){
		return {
			passwordInputs: {
				current: "",
				new: "",
				repeat: ""
			}
		};
	},
	computed: {
		isOwner():boolean{
			if (!AuthService.wfUser) return false;
			return AuthService.wfUser.ID == AuthService.wfCompany.OwnerID;
		},
		isLockScreenNfcEnabled():boolean{
			return LockScreenService.isNfcUnlockFeatureEnabled();
		}
	},
	components: {
		AppChangePassword,
		AppAccountSettings,
		AppBillingAddress,
		AppLockScreenNfcBadges,
		AppQrLogin
	}
});
